import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List } from 'immutable';
import Helmet from 'react-helmet';

import store, { loadProjects } from '../../state';

import MaxWidth from '../../components/max-width';
import Project from './project';

import './projects.css';

function getSlug(branch) {
  if (branch.match && branch.match.params) {
    return branch.match.params.slug;
  }
  return null;
}

class Projects extends Component {
  static fetchData(dispatch, branch) {
    return dispatch(loadProjects(getSlug(branch)));
  }

  constructor(props) {
    super(props);
    const { projects } = this.props;

    this.state = {
      slug: getSlug(this.props),
    };

    if (!projects) {
      store.dispatch(loadProjects(this.state.slug));
    }
  }

  render() {
    const { projects, intro, title } = this.props;

    const projectNodes = [];
    if (projects !== null) {
      projects.forEach((project) => {
        projectNodes.push(<Project project={project} key={`project-${project.get('slug')}`} />);
      });
    }

    return (
      <MaxWidth className="page projects-archive">
        <div className="page-title">
          <h3>{title}</h3>
        </div>
        <div className="page-content">
          <div className="intro" dangerouslySetInnerHTML={{ __html: intro }} />
          <div className="projects">
            {projects === null ? (
              <div>Loading Projects...</div>
            ) : projectNodes}
          </div>
        </div>
        <Helmet>
          <title>DCG Design | {title}</title>
        </Helmet>
      </MaxWidth>
    );
  }
}

Projects.defaultProps = {
  projects: null,
  intro: null,
  title: null,
};

Projects.propTypes = {
  projects: PropTypes.instanceOf(List),
  intro: PropTypes.string,
  title: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const slug = getSlug(ownProps);

  const title = state.getIn(['projectListings', slug, 'title']);
  const intro = state.getIn(['projectListings', slug, 'intro']);
  const tag = state.getIn(['projectListings', slug, 'tag']);
  const projects = state.getIn(['projectStubs', tag]);

  return {
    projects,
    title,
    intro,
  };
}

export default connect(mapStateToProps)(Projects);



// WEBPACK FOOTER //
// ./src/containers/projects/index.jsx